/* =============================================================================
   CREATIVE DETONATOR - HOME PAGE JAVASCRIPT
   Landing page specific functionality
   FRONTEND-21: XSS Prevention via window.Sanitize
   ============================================================================= */

// FRONTEND-21: Sanitization helpers (fallback if Sanitize not loaded)
const esc = (str) => window.Sanitize?.escapeHtml(str) || String(str).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const escAttr = (str) => window.Sanitize?.escapeAttr(str) || String(str).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

document.addEventListener('DOMContentLoaded', async () => {
  // Load data
  await DataStore.loadCategories();
  await DataStore.loadTriggers();

  // Render categories grid
  renderCategoriesGrid();

  // Render featured triggers
  renderFeaturedTriggers();
});

// Render Categories Grid on Home Page with Images (show first 8)
// FRONTEND-21: All dynamic content escaped
function renderCategoriesGrid() {
  const grid = document.getElementById('categories-grid');
  if (!grid) return;

  const categories = DataStore.categories;
  if (!categories) return;

  // Show only first 8 categories on homepage
  const displayCategories = categories.slice(0, 8);

  grid.innerHTML = displayCategories.map(cat => `
    <a href="features/triggers/pages/index.html#category-${escAttr(cat.code.toLowerCase())}" class="category-visual-card" style="--cat-color: ${escAttr(cat.color)}">
      <div class="category-visual-image">
        <img src="assets/images/categories/${escAttr(cat.code)}.png" alt="${escAttr(cat.name)}" loading="lazy">
      </div>
      <div class="category-visual-content">
        <div class="category-visual-header">
          <span class="category-visual-code">${esc(cat.code)}</span>
          <h3 class="category-visual-title">${esc(cat.name.toUpperCase())}</h3>
        </div>
        <p class="category-visual-mechanism">${esc(cat.mechanism)}</p>
        <span class="category-visual-count">${cat.triggerCount} TRIGGERS</span>
      </div>
    </a>
  `).join('');
}

// Render Featured Triggers with Images and Key Questions
// FRONTEND-21: All dynamic content escaped
function renderFeaturedTriggers() {
  const grid = document.getElementById('featured-triggers');
  if (!grid) return;

  const triggers = DataStore.triggers;
  if (!triggers) return;

  // Select diverse triggers that showcase the system well - one from each major category
  const featured = [
    triggers.find(t => t.code === 'A1'), // Pattern Interrupt - Impossible Visual
    triggers.find(t => t.code === 'B5'), // Emotional - Joy Spike
    triggers.find(t => t.code === 'C1'), // Cognitive - Missing Piece
    triggers.find(t => t.code === 'E1'), // Story - Micro-Drama
  ].filter(Boolean);

  grid.innerHTML = featured.map(trigger => {
    const color = CategoryColors[trigger.category];
    const imagePath = getTriggerImagePathFromCode(trigger.code, '');

    // SECURITY: Use data-code attribute instead of inline onerror to prevent XSS
    return `
      <a href="features/triggers/pages/detail.html?code=${escAttr(trigger.code)}" class="featured-trigger-card-enhanced" style="--cat-color: ${escAttr(color)}">
        <div class="featured-trigger-image">
          <img src="${escAttr(imagePath)}" alt="${escAttr(trigger.name)}" loading="lazy" data-trigger-code="${escAttr(trigger.code)}">
        </div>
        <div class="featured-trigger-content">
          <div class="featured-trigger-header">
            <span class="featured-trigger-code">${esc(trigger.code)}</span>
            <h3 class="featured-trigger-title">${esc(trigger.name.toUpperCase())}</h3>
          </div>
          <p class="featured-trigger-question">${esc(trigger.question)}</p>
          <span class="featured-trigger-cta">EXPLORE →</span>
        </div>
      </a>
    `;
  }).join('');

  // SECURITY: Add error handlers via addEventListener instead of inline onerror
  grid.querySelectorAll('img[data-trigger-code]').forEach(img => {
    img.addEventListener('error', function() {
      const code = this.dataset.triggerCode;
      const icon = getTriggerIcon(code);
      // Icon is from hardcoded TRIGGER_ICONS lookup, safe to use
      this.parentElement.innerHTML = `<span class="trigger-icon-fallback">${icon}</span>`;
    });
  });
}
